/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import ThumbsUpIcon from '../../../icons/illustrative/ThumbsUp';
import Link from '../../../base/Link';

export const IconStyled = styled(ThumbsUpIcon)`
${({ theme }) => {
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    let marginTop = 0;
    if (mediumUp) {
      marginTop = -25;
    }
    return css`
      width: ${rem(50)};
      margin-top: ${rem(marginTop)};
      margin-bottom: ${rem(10)};
    `;
  }
}`;

export const LinkStyled = styled(Link)`
  ${({ theme }) => css`
    color: ${theme.colors.neutral.white};
    text-decoration: underline;
    :hover {
      color: ${theme.colors.neutral.gray80};
    }
  `}
`;
